<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"></a><em class="italic">For all those families whose loved ones</em></p>
<p class="ded1"><em class="italic">did not return from the Great War.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Ded.vue?147cf1ee